import URI from '@dw/urijs-esm/index.js';
import { isAuthorizeFileStorePage } from './validate-url.js';

/**
 * @param {Object} data - Router data context
 * @return Promise -  If path is /reauthorize-cloud-store then resolve promise with re-authorized-file-store page data.
 *                    Otherwise reject a promise.
 */
export const authorizedFileStorePage = (data) => {
  return new Promise((resolve, reject) => {
    if(isAuthorizeFileStorePage(data.path)) {
      let params = new URI().query(true);
      data.page = {
        name: 'AUTHORIZE_FILE_STORE',
        params
      };
      resolve(data);
      return;
    }
    reject(data);
  });
}